export default function minIndex(values, valueof) {
    var min;
    var minIndex = -1;
    var index = -1;
    if (valueof === undefined) {
        for (var _i = 0, values_1 = values; _i < values_1.length; _i++) {
            var value = values_1[_i];
            ++index;
            if (value != null
                && (min > value || (min === undefined && value >= value))) {
                min = value, minIndex = index;
            }
        }
    }
    else {
        for (var _a = 0, values_2 = values; _a < values_2.length; _a++) {
            var value = values_2[_a];
            if ((value = valueof(value, ++index, values)) != null
                && (min > value || (min === undefined && value >= value))) {
                min = value, minIndex = index;
            }
        }
    }
    return minIndex;
}
